import createIcon from '../../createIcon';

/**
 * @component @name KeyboardArrowLeft
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTUuNzA0OSAxNi41OUwxMS4xMjQ5IDEyTDE1LjcwNDkgNy40MUwxNC4yOTQ5IDZMOC4yOTQ5MiAxMkwxNC4yOTQ5IDE4TDE1LjcwNDkgMTYuNTlaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const KeyboardArrowLeft = createIcon('KeyboardArrowLeft', [
  [
    'path',
    {
      d: 'M15.7049 16.59L11.1249 12L15.7049 7.41L14.2949 6L8.29492 12L14.2949 18L15.7049 16.59Z',
      key: '1bpdbw',
    },
  ],
]);

export default KeyboardArrowLeft;
